<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M3.23,792.5l-2.73,1.82v8.18l-2.73-10l2.73-1.82v-8.18L3.23,792.5z M-8.71,786.05l4.25,5.71l-1.46,1.98l1.87,5.13
	l-4.25-5.71l1.46-1.98L-8.71,786.05L-8.71,786.05z M9.3,793.16l-2.39,0.58l-1.87,5.13l0.41-7.11l2.39-0.58l1.87-5.13L9.3,793.16z"/>
</svg>

</template>